module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-rain-heavy-fill-263ad444.svg";